import React from 'react';
import { formatMoney } from '../../utils/format';

export function VehicleStats({ vehicle, t }) {
  const km = vehicle.km || 0;
  const days = vehicle.daysActive || 0;
  const revenue = vehicle.totalRevenue || 0;
  return (
    <div className="grid grid-cols-3 gap-2 text-center bg-ink-700/30 rounded-lg p-2 mt-2">
      <div>
        <p className="text-xs text-slate-500">{t('km_traveled')}</p>
        <p className="text-sm font-bold text-foreground">{km.toLocaleString('fr-FR')}</p>
      </div>
      <div>
        <p className="text-xs text-slate-500">{t('active_days')}</p>
        <p className="text-sm font-bold text-foreground">{days}</p>
      </div>
      <div>
        <p className="text-xs text-slate-500">{t('revenue_generated')}</p>
        <p className="text-sm font-bold text-money">{formatMoney(revenue)}</p>
      </div>
    </div>
  );
}
